import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')


const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

const Categories = () => import('@/views/category/Categories')
const Category = () => import('@/views/category/Category')

const Galeries = () => import('@/views/galery/Galeries')
const Galery = () => import('@/views/galery/Galery')

const Videos = () => import('@/views/video/Videos')
const Video = () => import('@/views/video/Video')

const Contents = () => import('@/views/content/Contents')
const Content = () => import('@/views/content/Content')

const Company = () => import('@/views/company/Company')

const Profile = () => import('@/views/profile/profile')
const Headline = () => import('@/views/headline/Headline')


// Views - Pages
const Page404 = () => import('@/views/auth/Page404')
const Page500 = () => import('@/views/auth/Page500')
const Login = () => import('@/views/auth/Login')
const ForgotPassword = () => import('@/views/auth/ForgotPassword')

Vue.use(Router)

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'headline',
          meta: { label: 'Headline'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Headline,
            },
          ]
        },
        {
          path: 'profile',
          meta: { label: 'Profile'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Profile,
            },
          ]
        },
        {
          path: 'users',
          meta: { label: 'Users'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Users,
            },
            {
              path: 'add',
              meta: { label: 'User Add'},
              name: 'User Add',
              component: User,
            },
            {
              path: 'edit/:id',
              meta: { label: 'User Edit'},
              name: 'User Edit',
              component: User,
            },
          ]
        },
        {
          path: 'galery',
          meta: { label: 'Galeries'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Galeries,
            },
            {
              path: 'add',
              meta: { label: 'Galery Add'},
              name: 'Galery Add',
              component: Galery,
            },
            {
              path: 'edit/:id',
              meta: { label: 'Galery Edit'},
              name: 'Galery Edit',
              component: Galery,
            },
          ]
        },

        {
          path: 'category',
          meta: { label: 'Categories'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Categories,
            },
            {
              path: 'add',
              meta: { label: 'Category Add'},
              name: 'Category Add',
              component: Category,
            },
            {
              path: 'edit/:id',
              meta: { label: 'Category Edit'},
              name: 'Category Edit',
              component: Category,
            },
          ]
        },

        {
          path: 'video',
          meta: { label: 'Videos'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Videos,
            },
            {
              path: 'add',
              meta: { label: 'Video Add'},
              name: 'Video Add',
              component: Video,
            },
            {
              path: 'edit/:id',
              meta: { label: 'Video Edit'},
              name: 'Video Edit',
              component: Video,
            },
          ]
        },
        {
          path: 'content',
          meta: { label: 'Content'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Contents,
            },
            {
              path: 'add',
              meta: { label: 'Content Add'},
              name: 'Content Add',
              component: Content,
            },
            {
              path: 'edit/:id',
              meta: { label: 'Content Edit'},
              name: 'Content Edit',
              component: Content,
            },
          ]
        },
        {
          path: 'company',
          meta: { label: 'Company'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Company,
            }
          ]
        }
      ]
    },
    {
      path: '/auth',
      redirect: '/auth/404',
      name: 'Auth',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'forgot_password',
          name: 'Forgot Password',
          component: ForgotPassword
        }
      ]
    }
  ]
})
